import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ProductCode } from '../../model/finzy-flex/product-list.model';
import { AttributeCode, InvestmentPreference } from '../../model/finzy-flex/user-attribute.model';
import { ConfigService } from '../../service/config.service';



@Component({
  selector: 'app-flex-swift-attribute',
  templateUrl: './flex-swift-attribute.component.html',
  styleUrls: ['./flex-swift-attribute.component.css']
})
export class FlexSwiftAttributeComponent implements OnInit {

  public formBuilder: FormBuilder;
  public subProducts = [];

  @Input() userAttributesSwiftForm?: FormGroup;

  @Input() applicableProducts?: any;
  
  @Input() backUpUserAttributes?: InvestmentPreference[] = [];

  @Output() userAttributesSwiftFormValue = new EventEmitter<InvestmentPreference[]>()
  
  isSwiftEnabled?: boolean = true;

  constructor(formBuilder: FormBuilder, private readonly configService: ConfigService) {
    this.formBuilder = formBuilder;
  }

  ngOnInit(): void {
    this.initializeForm();
  }

  private async initializeForm() {
    this.fundAllocationPercent.clear();

    this.applicableProducts?.forEach((product: any) => {
      if (new Date(product.productVersions[0].startDate).getTime() <= new Date().getTime() &&
        new Date().getTime() <= new Date(product.productVersions[0].endDate).getTime()) {
        this.subProducts.push({
          name: product.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME) ? product.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME).value.toString() : product.name,
          category: product.productVersions[0].productVersion ? this.getProductCodeVariantCategory(product.productVersions[0].productAttributes.find(attribute => attribute.code == ProductCode.NAME).value.toString(), product.productVersions[0].productVersion) : null,
          mhp: product.productVersions[0].productAttributes.find(mhp => mhp.code === ProductCode.MHP_FRONTEND_DISPLAY)?.value,
          mhpName: product.productVersions[0].productAttributes.find(mhp => mhp.code === ProductCode.MHP)?.name ?? 'mhp',
          roi: product.productVersions[0].productAttributes.find(roi => roi.code === ProductCode.ROI).value,
          maturity_days: product.productVersions[0].productAttributes.find(roi => roi.code === ProductCode.MATURITY_DAYS)?.value,
        });
        this.fundAllocationPercent.push(
          this.formBuilder.group({
            attributeCode: AttributeCode.FF_REINVEST_PRO_FUND_ALLOCATION,
            attributeValue: this.formBuilder.control(this.getPreviousSwiftValue(product.code), [Validators.min(0), Validators.max(100)]),
            productCode: product.code,
            productVersion: product.productVersions[0].productVersion
          })
        )
      }
    });
  }

  private getPreviousSwiftValue(productCode: string): number {
    if (this.isSwiftEnabled) {
      const attributeValue = this.backUpUserAttributes.find(attr => attr.productCode === productCode)?.attributeValue;
      return attributeValue ? parseInt(attributeValue) : null;
    }
    return;
  }

  get fundAllocationPercent(): FormArray {
    return this.userAttributesSwiftForm.controls['fundAllocationPercent'] as FormArray;
  }

  public onInputChanges(event): any {
    this.userAttributesSwiftFormValue.emit(this.userAttributesSwiftForm.get('fundAllocationPercent')?.value);
    try {
      const numberInput = event.path[1].getElementsByClassName('input-field');
      const inputLabel = event.path[1].getElementsByClassName('input-label');
      inputLabel[0].style.color = "#a6a6a6";
      numberInput[0].style.fontWeight = "900";
      numberInput[0].style.fontSize = "16px";
      numberInput[0].style.letterSpacing = "0.5px";
      if (event.target.value == '') {
        inputLabel[0].style.color = "#000000";
        numberInput[0].style.fontWeight = "400";
      }
    } catch (e) {
      return;
    }
  }

  public isNumberKey(e): boolean {
    const charCode = (e.which) ? e.which : e.keyCode;
    return !(charCode > 31 && (charCode < 48 || charCode > 57));
  }

  private getProductCodeVariantCategory(productCode: string, productVersion: number): string {
    const productVariantCategoryOne: number = Number(this.configService.getLenderProductVariantCategoryOne());
    const productVariantCategoryTwo: number = Number(this.configService.getLenderProductVariantCategoryTwo());

    console.log("productVariantCategoryOne : ", productVariantCategoryOne);
    console.log("productVariantCategoryTwo : ", productVariantCategoryTwo);
    console.log("productCode : ", productCode);
    console.log("productVersion : ", productVersion);

    if(productCode) {
      switch (Number(productVersion)) {
        case productVariantCategoryOne:
          return `C1`
        case productVariantCategoryTwo:
          return `C2`
        default:
          return null;
      }
    }
	} 

}
